import { combineReducers } from 'redux'
import { Inbox, OrgProperties, OrgSettings } from 'shared/src/typings/bootstrap'
import { fetchBootstrapAsync } from 'shared/store/actions/bootstrap'

import { AnyRootAction, createReducer } from 'typesafe-actions'

const orgSettings = createReducer<OrgSettings | Record<string, undefined>, AnyRootAction>(
  {}
).handleAction([fetchBootstrapAsync.success], (_, action) => {
  return action.payload.org?.settings ?? {}
})

const orgProperties = createReducer<OrgProperties | Record<string, undefined>, AnyRootAction>(
  {}
).handleAction([fetchBootstrapAsync.success], (_, action) => {
  return action.payload.org?.properties ?? {}
})

const inboxes = createReducer<Inbox[], AnyRootAction>([]).handleAction(
  fetchBootstrapAsync.success,
  (_, action) => {
    return action.payload.org?.inboxes ?? []
  }
)

export default combineReducers({
  orgSettings,
  orgProperties,
  inboxes,
})
